<template>
  <modal
    size="xl"
    :title="
      'Add Manuel Reservation' +
        (data != null ? ' (' + data.Detail.Subject + ')' : '')
    "
    @close="$emit('close')"
  >
    <template #content>
      <load-area v-if="data == null"></load-area>
      <div v-if="data != null">
        <ul class="nav nav-tabs profile-tab" v-if="data.Attachments.length > 0">
          <li class="nav-item m-0">
            <a
              href="javascript:;"
              class="nav-link"
              :class="{ active: tab == 'mail' }"
              @click="tab = 'mail'"
              >Mail</a
            >
          </li>
          <li class="nav-item m-0">
            <a
              href="javascript:;"
              class="nav-link"
              :class="{ active: tab == 'document' }"
              @click="tab = 'document'"
              >Döküman</a
            >
          </li>
        </ul>
        <div class="row">
          <div class="col border-right p-r-0">
            <template v-if="tab == 'mail'">
              <load-area v-if="mailDetail == null"></load-area>
              <div v-if="mailDetail != null" v-html="mailDetail"></div>
            </template>

            <object
              v-if="tab == 'document'"
              :data="
                'https://reservations.ams3.digitaloceanspaces.com/attachments/' +
                  data.Attachments[0].BucketFileName
              "
              type="application/pdf"
              width="100%"
              height="100%"
              style="min-height:1000px"
              aria-expanded="false"
            >
              <p>
                Pdf açamıyoruz. <a :href="fileUri"> Buraya </a> tıklayarak
                görüntüleyebilirsiniz
              </p>
            </object>
          </div>
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels col-auto p-l-0"
            ref="form"
          >
            <ol class="resTab border-bottom">
              <li
                v-for="(item, index) in model"
                :key="index"
                :class="{ active: tabRes == index, noTrash: model.length == 1 }"
                @click="changeRessTab(index)"
              >
                {{ index + 1 }}. Reservation
                <i
                  class="fas fa-times"
                  @click="removeResTab(index)"
                  v-if="model.length > 1"
                ></i>
              </li>
            </ol>
            <ul :key="tabRes">
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Confirmation Type'"
                    v-model="model[tabRes].ConfirmationType.Code"
                    :errors="errors"
                    @keydown.enter="save"
                    :rules="{ required: true }"
                    placeholder="..."
                    :as="'select'"
                  >
                    <template #input>
                      <option :value="1">New</option>
                      <option :value="2">Changed</option>
                      <option :value="3">Cancelled</option>
                      <option :value="-1">None</option>
                    </template>
                  </formGroup>
                </div>
                <div class="col">
                  <searchSelect
                    :title="'Customer'"
                    v-model="modelOther.CustomerId"
                    :errors="errors"
                    :data="
                      customers.map((x) => {
                        return {
                          value: x.Id,
                          text: x.Name,
                        };
                      })
                    "
                    @change="getCustomerProviders()"
                    placeholder="..."
                  >
                  </searchSelect>
                  <!-- <formGroup
                    :title="'Customer'"
                    v-model="modelOther.CustomerId"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                    :rules="{ required: true }"
                    :as="'select'"
                    @change="getCustomerProviders()"
                  >
                    <template #input>
                      <option value="" hidden>...</option>
                      <option
                        v-for="item in customers"
                        :value="item.Id"
                        :key="item.Id"
                        >{{ item.Name }}</option
                      >
                    </template>
                  </formGroup> -->
                </div>
                <div class="col">
                  <searchSelect
                    :title="'Customer Provider'"
                    v-model="modelOther.CustomerProviderId"
                    :errors="errors"
                    :data="
                      customerProviders == null
                        ? []
                        : customerProviders.map((x) => {
                            return {
                              value: x.Id,
                              text:
                                x.Id +
                                ' - ' +
                                x.ProviderName +
                                ' - ' +
                                x.Username,
                            };
                          })
                    "
                    :disabled="customerProviders == null"
                    placeholder="..."
                  >
                  </searchSelect>
                  <!-- <formGroup
                    :title="'Customer Provider'"
                    v-model="modelOther.CustomerProviderId"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                    :rules="{ required: true }"
                    :as="'select'"
                    :disabled="customerProviders == null"
                  >
                    <template v-if="customerProviders != null" #input>
                      <option value="" hidden>...</option>
                      <option
                        v-for="item in customerProviders"
                        :value="item.Id"
                        :key="item.Id"
                        >{{ item.Id }} - {{ item.ProviderName }} -
                        {{ item.Username }}</option
                      >
                    </template>
                  </formGroup> -->
                </div>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Provider Hotel Name'"
                    v-model="model[tabRes].ProviderHotelName"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Tour Operator Name'"
                    v-model="model[tabRes].Agency.TourOperatorName"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Agency'"
                    v-model="model[tabRes].Agency.Name"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Client Voucher'"
                    v-model="model[tabRes].Voucher.Client"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                    @keyup="
                      model[tabRes].Voucher.Operator =
                        model[tabRes].Voucher.Client;
                      model[tabRes].Voucher.Full =
                        model[tabRes].Voucher.Client ==
                        model[tabRes].Voucher.Operator
                          ? model[tabRes].Voucher.Client
                          : model[tabRes].Voucher.Operator +
                            '/' +
                            model[tabRes].Voucher.Client;
                    "
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Operator Voucher'"
                    v-model="model[tabRes].Voucher.Operator"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                    @keyup="
                      model[tabRes].Voucher.Full =
                        model[tabRes].Voucher.Client ==
                        model[tabRes].Voucher.Operator
                          ? model[tabRes].Voucher.Client
                          : model[tabRes].Voucher.Operator +
                            '/' +
                            model[tabRes].Voucher.Client
                    "
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Full Voucher'"
                    v-model="model[tabRes].Voucher.Full"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Checkin'"
                    v-model="model[tabRes].Checkin"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    type="date"
                    placeholder="..."
                    :max="model[tabRes].Checkout"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Checkout'"
                    v-model="model[tabRes].Checkout"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    type="date"
                    placeholder="..."
                    :min="model[tabRes].Checkin"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Sale Date'"
                    v-model="model[tabRes].Sale.Date"
                    :errors="errors"
                    :rules="{ required: model[tabRes].Sale.IsAgencySaleDate }"
                    @keydown.enter="save"
                    type="date"
                    placeholder="..."
                    :checkDisabled="true"
                    :disabled="!model[tabRes].Sale.IsAgencySaleDate"
                  >
                    <template #checkDisabled>
                      <formGroup
                        as="checkbox"
                        v-model="model[tabRes].Sale.IsAgencySaleDate"
                        :errors="errors"
                        :rules="{ max: 4000 }"
                        @keydown.enter="save"
                      ></formGroup> </template
                  ></formGroup>
                </div>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Room Name'"
                    v-model="model[tabRes].Room.Name"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Room Detail'"
                    v-model="model[tabRes].Room.RoomDetail"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Room Count'"
                    v-model.number="model[tabRes].Room.Count"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                    :rules="{ required: true }"
                  ></formGroup>
                </div>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Pension'"
                    v-model="model[tabRes].Pension"
                    :errors="errors"
                    :rules="{ required: true }"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Provider Market'"
                    v-model="model[tabRes].ProviderMarket"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
              </li>
              <li><strong>Guests</strong></li>
              <li>
                <table>
                  <thead>
                    <tr>
                      <th>Gender</th>
                      <th>Name</th>
                      <th>Surname</th>
                      <th>BirthDate</th>
                      <th>Age</th>
                      <th>D.No</th>
                      <th>Cts</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in model[tabRes].Persons"
                      :key="index"
                    >
                      <td>
                        <formGroup
                          :title="'Gender' + index"
                          v-model="item.Gender.Code"
                          :errors="errors"
                          @keydown.enter="save"
                          :rules="{ required: true }"
                          placeholder="..."
                          :as="'select'"
                          @change="calculatePax()"
                        >
                          <template #input>
                            <option :value="1">Mr</option>
                            <option :value="2">Mrs</option>
                            <option :value="3">Chd</option>
                            <option :value="4">Inf</option>
                            <option :value="-1">None</option>
                          </template>
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Name' + index"
                          v-model="item.Name"
                          :errors="errors"
                          @keydown.enter="save"
                          :rules="{ required: true }"
                          placeholder="..."
                          @keydown="
                            item.Name = item.Name == 'No Name' ? '' : item.Name
                          "
                          @blur="
                            item.Name =
                              item.Name.trim() == '' ? 'No Name' : item.Name
                          "
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Surname' + index"
                          v-model="item.Surname"
                          :errors="errors"
                          @keydown.enter="save"
                          :rules="{ required: true }"
                          placeholder="..."
                          @keydown="
                            item.Surname =
                              item.Surname == 'No Name' ? '' : item.Surname
                          "
                          @blur="
                            item.Surname =
                              item.Surname.trim() == ''
                                ? 'No Name'
                                : item.Surname
                          "
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'BirthDate' + index"
                          v-model="item.BirthDate"
                          :errors="errors"
                          @keydown.enter="save"
                          placeholder="..."
                          type="date"
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Age' + index"
                          v-model="item.Age"
                          :errors="errors"
                          @keydown.enter="save"
                          placeholder="..."
                          type="number"
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'DocumentNumber' + index"
                          v-model="item.DocumentNumber"
                          :errors="errors"
                          @keydown.enter="save"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Citizenship' + index"
                          v-model="item.Citizenship"
                          :errors="errors"
                          @keydown.enter="save"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <button
                          class="btn btn-xs btn-success waves-effect waves-light"
                          type="button"
                          @click="personAdd(item)"
                        >
                          <i class="fas fa-clone"></i>
                        </button>
                        <button
                          class="btn btn-xs btn-danger waves-effect waves-light"
                          type="button"
                          @click="trashPersons(index)"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <formGroup
                          :title="'Gender'"
                          v-model="addPerson.Gender.Code"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          :rules="{ required: true }"
                          placeholder="..."
                          :as="'select'"
                        >
                          <template #input>
                            <option :value="1">Mr</option>
                            <option :value="2">Mrs</option>
                            <option :value="3">Chd</option>
                            <option :value="4">Inf</option>
                            <option :value="-1">None</option>
                          </template>
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Name'"
                          v-model="addPerson.Name"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          :rules="{ required: true }"
                          placeholder="..."
                          @keydown="
                            addPerson.Name =
                              addPerson.Name == 'No Name' ? '' : addPerson.Name
                          "
                          @blur="
                            addPerson.Name =
                              addPerson.Name.trim() == ''
                                ? 'No Name'
                                : addPerson.Name
                          "
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Surname'"
                          v-model="addPerson.Surname"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          :rules="{ required: true }"
                          placeholder="..."
                          @keydown="
                            addPerson.Surname =
                              addPerson.Surname == 'No Name'
                                ? ''
                                : addPerson.Surname
                          "
                          @blur="
                            addPerson.Surname =
                              addPerson.Surname.trim() == ''
                                ? 'No Name'
                                : addPerson.Surname
                          "
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'BirthDate'"
                          v-model="addPerson.BirthDate"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          placeholder="..."
                          type="date"
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Age'"
                          v-model="addPerson.Age"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          placeholder="..."
                          type="number"
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'DocumentNumber'"
                          v-model="addPerson.DocumentNumber"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Citizenship'"
                          v-model="addPerson.Citizenship"
                          :errors="errors"
                          @keydown.enter="personAdd()"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <button
                          class="btn btn-xs btn-success waves-effect waves-light"
                          type="button"
                          @click="personAdd()"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </li>
              <li></li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Adult'"
                    v-model="modelOther.Adult"
                    :errors="errors"
                    @keydown.enter="save"
                    :disabled="true"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Child'"
                    v-model="modelOther.Child"
                    :errors="errors"
                    @keydown.enter="save"
                    :disabled="true"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Infant'"
                    v-model="modelOther.Infant"
                    :errors="errors"
                    @keydown.enter="save"
                    :disabled="true"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'None'"
                    v-model="modelOther.None"
                    :errors="errors"
                    @keydown.enter="save"
                    :disabled="true"
                  ></formGroup>
                </div>
              </li>
              <li><strong>Notes</strong></li>
              <li>
                <table>
                  <thead>
                    <tr>
                      <th width="100">Type</th>
                      <th>Content</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in model[tabRes].Notes"
                      :key="index"
                    >
                      <td>
                        <formGroup
                          :title="'Type' + index"
                          v-model="item.Type"
                          :errors="errors"
                          @keydown.enter="save"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Content' + index"
                          v-model="item.Content"
                          :errors="errors"
                          @keydown.enter="save"
                          :rules="{ required: true }"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <button
                          class="btn btn-xs btn-danger waves-effect waves-light"
                          type="button"
                          @click="
                            model[tabRes].Notes = model[tabRes].Notes.filter(
                              (x) => x.Content != item.Content
                            )
                          "
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <formGroup
                          :title="'Type'"
                          v-model="addNote.Type"
                          :errors="errors"
                          @keydown.enter="noteAdd()"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <formGroup
                          :title="'Content'"
                          v-model="addNote.Content"
                          :errors="errors"
                          @keydown.enter="noteAdd()"
                          placeholder="..."
                        >
                        </formGroup>
                      </td>
                      <td>
                        <button
                          class="btn btn-xs btn-success waves-effect waves-light"
                          @click="noteAdd()"
                          type="button"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </li>
              <li><strong></strong></li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Departure Date'"
                    v-model="model[tabRes].Departure.Date"
                    :errors="errors"
                    @keydown.enter="save"
                    type="date"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Departure Flight Code'"
                    v-model="model[tabRes].Departure.FlightCode"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Departure City'"
                    v-model="model[tabRes].Departure.City"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'Arrival Date'"
                    v-model="model[tabRes].Arrival.Date"
                    :errors="errors"
                    @keydown.enter="save"
                    type="date"
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Arrival Flight Code'"
                    v-model="model[tabRes].Arrival.FlightCode"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
                <div class="col">
                  <formGroup
                    :title="'Arrival City'"
                    v-model="model[tabRes].Arrival.City"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                  ></formGroup>
                </div>
              </li>
              <li>
                <formGroup
                  :title="'Parameter P1'"
                  v-model="model[tabRes].Parameters.P1"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li
                v-if="
                  model[tabRes].Parameters.P1 != null &&
                    model[tabRes].Parameters.P1 != ''
                "
              >
                <formGroup
                  :title="'Parameter P2'"
                  v-model="model[tabRes].Parameters.P2"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li
                v-if="
                  model[tabRes].Parameters.P2 != null &&
                    model[tabRes].Parameters.P2 != ''
                "
              >
                <formGroup
                  :title="'Parameter P3'"
                  v-model="model[tabRes].Parameters.P3"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li
                v-if="
                  model[tabRes].Parameters.P3 != null &&
                    model[tabRes].Parameters.P3 != ''
                "
              >
                <formGroup
                  :title="'Parameter P4'"
                  v-model="model[tabRes].Parameters.P4"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li
                v-if="
                  model[tabRes].Parameters.P4 != null &&
                    model[tabRes].Parameters.P4 != ''
                "
              >
                <formGroup
                  :title="'Parameter P5'"
                  v-model="model[tabRes].Parameters.P5"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li>
                <formGroup
                  :title="'Confirm Link'"
                  v-model="model[tabRes].ConfirmLink"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li>
                <formGroup
                  :title="'Not Confirm Link'"
                  v-model="model[tabRes].NotConfirmLink"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                ></formGroup>
              </li>
              <li>
                <formGroup
                  :title="'Bound Key'"
                  v-model="model[tabRes].BoundKey"
                  :errors="errors"
                  @keydown.enter="save"
                  placeholder="..."
                  :checkDisabled="true"
                  :disabled="!modelOther.isBoundKey"
                >
                  <template #checkDisabled>
                    <formGroup
                      as="checkbox"
                      v-model="modelOther.isBoundKey"
                      :errors="errors"
                      :rules="{ max: 4000 }"
                      @keydown.enter="save"
                      @change="createGuid"
                    ></formGroup> </template
                ></formGroup>
              </li>
              <li class="row">
                <div class="col">
                  <formGroup
                    :title="'File Name'"
                    v-model="model[tabRes].FileName"
                    :errors="errors"
                    @keydown.enter="save"
                    placeholder="..."
                    :disabled="true"
                  ></formGroup>
                </div>
                <div class="col-auto">
                  <label
                    for="inputFile"
                    class="btn btn-primary"
                    style="border-radius:0; left:0; transform:unset; top:0; position:unset; background:#7460ee; color:#ƒƒƒ; padding:0;
                    line-height:30px; width:36px; display:block;"
                  >
                    <i class="fas fa-upload" style="color:#fff"></i>
                  </label>
                  <input
                    type="file"
                    class="none"
                    id="inputFile"
                    @change="updatePdf($event)"
                  />
                </div>
              </li>
            </ul>
            <div class="row m-0">
              <div class="col p-0">
                <Btn
                  class="btn waves-effect waves-light btn-primary w100 text-center"
                  style="border-radius:0;"
                  @click="add()"
                  :process="process"
                  >Add Reservation</Btn
                >
              </div>
              <div class="col-auto p-0">
                <Btn
                  class="btn waves-effect waves-light btn-success w100 text-center"
                  style="border-radius:0;"
                  @click="save()"
                  :process="process"
                  >Send Reservation</Btn
                >
              </div>
            </div>
          </Form>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import loadArea from "../../../../components/loadArea.vue";
import axios from "axios";
export default {
  components: { loadArea },
  name: "addManuelReservation",
  props: ["customers", "mailId"],
  data() {
    return {
      data: null,
      tab: "mail",
      tabRes: 0,
      mailDetail: null,
      customerProvidersProcess: false,
      customerProviders: null,
      model: [
        {
          ConfirmationType: {
            Code: 1, //new = 1, changed = 2, cancel = 3, none = -1
            ProviderConfirmationType: "", //new,changed or cancel
          },
          ProviderHotelName: "",
          Agency: {
            Name: "",
            TourOperatorName: null,
          },
          Voucher: {
            Full: "",
            Operator: "",
            Client: "",
          },
          Checkin: "",
          Checkout: "",
          Sale: {
            Date: "", //dökümanda varsa satış tarihi yoksa
            IsAgencySaleDate: false, //dökümanda satış tarihi varsa true olacak
          },
          Room: {
            Name: "",
            RoomDetail: null, //başka oda bilgisi varsa
            Count: 1,
          },
          Pension: "", //dökümanda yazdığı şekilde olması lazım yoksa match olmaz
          ProviderMarket: null,
          Persons: [
            {
              Gender: {
                Code: 1,
              },
              Name: "No Name",
              Surname: "No Name",
              BirthDate: null,
              Age: null,
              DocumentNumber: null,
              Citizenship: null,
            },
          ],
          Notes: [],
          Departure: {
            Date: null,
            FlightCode: null,
            City: null,
          },
          Arrival: {
            Date: null,
            FlightCode: null,
            City: null,
          },
          Parameters: {
            P1: null,
            P2: null,
            P3: null,
            P4: null,
            P5: null,
          },
          ConfirmLink: null,
          NotConfirmLink: null,
          BoundKey: "",
          IsMail: true,
          MailId: this.mailId,
          FileName: null,
          DetailContentUrl: null, //mailden gelecek
          FileDownloaded: false,
        },
      ],
      modelOther: {
        CustomerId: null,
        CustomerProviderId: null,
        Adult: 1,
        Child: 0,
        Infant: 0,
        None: 0,
        isBoundKey: false,
      },
      addPerson: {
        Gender: {
          Code: 1,
        },
        Name: "No Name",
        Surname: "No Name",
        BirthDate: "",
        Age: null,
        DocumentNumber: null,
        Citizenship: null,
      },
      addNote: {
        Type: "",
        Content: "",
      },
      process: false,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`KOLAYREZ/Mails/` + this.mailId)
      .then((response) => {
        this.data = response.data;
        if (this.data.Attachments.length > 0) {
          this.tab = "document";
        }
        this.model[
          this.tabRes
        ].DetailContentUrl = this.data.Detail.ContentFileUrl;
        this.getContentFileName();
      })
      .catch((err) => {
        this.$isError(err);
        this.$emit("close");
      });
  },
  methods: {
    getContentFileName() {
      axios
        .get(
          "https://reservations.ams3.digitaloceanspaces.com/bodies/" +
            this.data.Detail.ContentFileName
        )
        .then((response) => {
          this.mailDetail = response.data;
        });
    },
    getCustomerProviders() {
      this.customerProvidersProcess = true;
      this.customerProviders = null;
      this.$appAxiosAdmin
        .get(`Customers/` + this.modelOther.CustomerId + `/CustomerProviders`)
        .then((response) => {
          this.customerProviders = response.data;
          this.customerProvidersProcess = false;
        });
    },
    personAdd(model) {
      if (model == undefined) {
        this.addPerson.Name =
          this.addPerson.Name.trim() == "" ? "No Name" : this.addPerson.Name;
        this.addPerson.Surname =
          this.addPerson.Surname.trim() == ""
            ? "No Name"
            : this.addPerson.Surname;
      }
      this.model[this.tabRes].Persons.push(
        JSON.parse(
          JSON.stringify(
            model != undefined ? { ...model } : { ...this.addPerson }
          )
        )
      );
      this.calculatePax();
    },
    trashPersons(index) {
      let data = [];
      this.model[this.tabRes].Persons.forEach((element, i) => {
        if (index != i) {
          data.push(element);
        }
      });
      this.model[this.tabRes].Persons = data;
      this.calculatePax();
    },
    calculatePax() {
      this.modelOther.Adult = 0;
      this.modelOther.Child = 0;
      this.modelOther.Infant = 0;
      this.modelOther.None = 0;
      this.model[this.tabRes].Persons.forEach((element) => {
        if (element.Gender.Code < 3 && element.Gender.Code > 0) {
          this.modelOther.Adult++;
        }
        if (element.Gender.Code == 3) {
          this.modelOther.Child++;
        }
        if (element.Gender.Code == 4) {
          this.modelOther.Infant++;
        }
        if (element.Gender.Code == -1) {
          this.modelOther.None++;
        }
      });
    },

    noteAdd() {
      if (this.addNote.Content.trim() == "") {
        return false;
      }
      this.model[this.tabRes].Notes.push({
        ...this.addNote,
      });
      this.addNote.Type = "";
      this.addNote.Content = "";
    },
    createGuid() {
      if (
        this.model[this.tabRes].BoundKey == "" &&
        this.modelOther.isBoundKey
      ) {
        this.model[
          this.tabRes
        ].BoundKey = "10000000-1000-4000-8000-100000000000".replace(
          /[018]/g,
          (c) =>
            (
              +c ^
              (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
            ).toString(16)
        );
      }
    },
    updatePdf(e) {
      var data = new FormData();
      var files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        data.append("File", files[0]);
      } else {
        return false;
      }
      this.uploadPhoto = true;
      axios
        .post(
          `https://api.kolayrez.com/mailworker/Upload/` +
            this.modelOther.CustomerProviderId,
          data
        )
        .then((response) => {
          this.model[this.tabRes].FileName = response.data;
          this.model[this.tabRes].FileDownloaded = true;
        });
    },
    changeRessTab(i) {
      if (this.model.length <= i) {
        return false;
      }
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.tabRes = i;
          this.calculatePax();
        }
      });
    },
    removeResTab(index) {
      this.tabRes = 0;
      let data = [];
      this.model.forEach((element, i) => {
        if (i != index) {
          data.push(element);
        }
      });
      this.model = data;
      this.calculatePax();
    },
    add() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.model.push(
            JSON.parse(JSON.stringify({ ...this.model[this.tabRes] }))
          );
          this.tabRes = this.model.length - 1;
        }
      });
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          axios
            .post(
              `https://api.kolayrez.com/mailworker/AddReservation/` +
                this.modelOther.CustomerProviderId,
              this.model
            )
            .then(() => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The reservation has been successfully added.",
                showCancelButton: true,
                confirmButtonText: "Clear Form",
                cancelButtonText: "Okey",
              }).then((question) => {
                console.log("question", question);
                if (question.isConfirmed) {
                  this.model = [
                    {
                      ConfirmationType: {
                        Code: 1,
                        ProviderConfirmationType: "",
                      },
                      ProviderHotelName: this.model[this.tabRes]
                        .ProviderHotelName,
                      Agency: {
                        Name: this.model[this.tabRes].Agency.name,
                        TourOperatorName: null,
                      },
                      Voucher: {
                        Full: "",
                        Operator: "",
                        Client: "",
                      },
                      Checkin: "",
                      Checkout: "",
                      Sale: {
                        Date: "",
                        IsAgencySaleDate: false,
                      },
                      Room: {
                        Name: "",
                        RoomDetail: null,
                        Count: 1,
                      },
                      Pension: "",
                      ProviderMarket: null,
                      Persons: [
                        {
                          Gender: {
                            Code: 1,
                          },
                          Name: "No Name",
                          Surname: "No Name",
                          BirthDate: null,
                          Age: null,
                          DocumentNumber: null,
                          Citizenship: null,
                        },
                      ],
                      Notes: [],
                      Departure: {
                        Date: null,
                        FlightCode: null,
                        City: null,
                      },
                      Arrival: {
                        Date: null,
                        FlightCode: null,
                        City: null,
                      },
                      Parameters: {
                        P1: null,
                        P2: null,
                        P3: null,
                        P4: null,
                        P5: null,
                      },
                      ConfirmLink: null,
                      NotConfirmLink: null,
                      BoundKey: this.model[this.tabRes].BoundKey,
                      IsMail: true,
                      MailId: this.mailId,
                      FileName: this.model[this.tabRes].FileName,
                      DetailContentUrl: this.model[this.tabRes]
                        .DetailContentUrl,
                      FileDownloaded: this.model[this.tabRes].FileDownloaded,
                    },
                  ];
                  this.modelOther = {
                    CustomerId: this.modelOther.CustomerId,
                    CustomerProviderId: this.modelOther.CustomerProviderId,
                    Adult: 1,
                    Child: 0,
                    Infant: 0,
                    None: 0,
                    isBoundKey: this.modelOther.isBoundKey,
                  };
                }
              });
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
/deep/ .modal-xl {
  max-width: 1440px;
}

.resTab {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0;
  white-space: nowrap;
  overflow: auto;
}
.resTab li {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  margin: 0;
  cursor: pointer;
  position: relative;
  padding-right: 30px;
}
.resTab li.noTrash {
  padding-right: 8px;
}
.resTab li i {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 26px;
  width: 26px;
  text-align: center;
  display: block;
  background: rgba(0, 0, 0, 0.1);
}
.resTab li.active {
  color: #fff;
  background: #1e88e5;
}
form {
  width: 560px;
}
form ul li {
  border-bottom: 1px solid #dee2e6;
}
form ul li > strong {
  display: block;
  text-align: center;
  color: #263238;
  font-weight: 500;
  font-size: 14px;
  padding: 8px;
  padding-top: 16px;
}
form ul li:nth-child(even) {
  background: #f6f6f6;
}
form ul li.row {
  margin: 0;
}
form ul li.row > div {
  padding: 0;
}
form ul li /deep/ .form-group {
  margin: 0;
}
form ul li /deep/ .form-group .form-control {
  border: none;
  padding: 12px 5px 2px;
  height: auto;
  line-height: 18px;
  min-height: 24px;
  font-size: 12px;
  background: none;
}
form ul li /deep/ .form-group .control-label {
  top: 0;
  font-size: 10px;
  background: none;
  padding: 0;
  transform: unset;
}
form ul li /deep/ .form-group.checkDisabled {
  padding-left: 0;
}
form ul li /deep/ .form-group.checkDisabled {
  padding-left: 25px;
}
form ul li /deep/ .form-group.checkDisabled .checkDisabled {
  background: none;
  border: none;
  padding: 0;
  top: 50%;
  margin-top: -10px;
  height: 20px;
  left: 5px;
  width: auto;
}
form ul li /deep/ .form-group.checkDisabled .control-label {
  left: 30px;
}
form ul li /deep/ .form-group .form-control-feedback {
  display: none;
}
form ul li table {
  width: 100%;
}
form ul li table thead {
  font-size: 12px;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 5px;
}
form ul li table thead tr th {
  padding: 6px 5px;
}
form ul li table /deep/ .form-group .control-label {
  display: none;
}
form ul li table /deep/ .form-group .form-control {
  padding: 2px 5px;
}
form ul li table td {
  padding: 0;
}
form ul li table td:last-child {
  text-align: right;
  font-size: 0;
  white-space: nowrap;
  vertical-align: middle;
}
form ul li table td:last-child .btn {
  margin: 0;
  display: inline-block;
  border-radius: 0;
}
form ul li table tbody tr:nth-child(even) {
  background: rgba(0, 0, 0, 0.045);
}
form ul li table tfoot {
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
